export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5967.62f4ea1e.jpg";